import { useEffect, useRef } from "react";
import { useConsenso } from "@/lib/consenso";

window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

const stato = (ok) => {
  const v = ok ? "granted" : "denied";
  return { analytics_storage: v, ad_storage: v, ad_user_data: v, ad_personalization: v };
};

// GTM snippet + Consent Mode default live in public/index.html; here we only sync the user's choice.
export const useGoogleTagManager = () => {
  const consenso = useConsenso();
  const ok = consenso?.statistiche === true;
  const primo = useRef(true);
  useEffect(() => {
    if (primo.current) { primo.current = false; if (!ok) return; }
    gtag("consent", "update", stato(ok));
    window.dataLayer.push({ event: "consenso_aggiornato", consenso_statistiche: ok });
  }, [ok]);
};
